import { EntityService } from '@/services/EntityService';

export class DocumentsLinksService extends EntityService {
  static get entity() {
    return 'documents/links';
  }
}
